import Vue from 'vue'
import Router from 'vue-router'

// Containers
import Full from '@/containers/Full'

// Views - Auth
// import Register from '@/views/auth/Register'
import LogIn from '@/views/auth/Login'
import ManualLogin from '@/views/auth/ManualLogin'
import ResetPassword from '@/views/auth/ResetPassword'
import Auth from '@/views/auth/Auth'

// Views - Submission
import submitForm from '@/views/submit/submitForm'

// Views - Templates
import ListTemplate from '@/views/templates/List'
import NewTemplate from '@/views/templates/New'
import TrainTemplate from '@/views/templates/Train'

// Views - Process
import uploadProcess from '@/views/process/Upload'
import processedForms from '@/views/process/ProcessedForms'
import processDoc from '@/views/docs/processDoc'
import processForm from '@/views/forms/processForm'
import modifyProcessType from '@/views/forms/modifyProcessType'

// Views - Reports
import formsReport from '@/views/reports/Form'
import formsInsights from '@/views/reports/formsInsights'
import auditLogs from '@/views/reports/auditLogs'

// Views - Audits
import auditsTrail from '@/views/audits/Trail'

// Views - Feature Flags
import FeatureFlag from '@/views/featureflag/FeatureFlag'

// Views - Pages
import Page404 from '@/views/pages/Page404'

import users from '@/views/admin/users'
import newUser from '@/views/admin/newUser'
import editUser from '@/views/admin/editUser'
import configure from '@/views/settings/configurations'
import formStatus from '@/views/admin/formStatus'
import accounts from '@/views/superAdmin/accounts'
import newAccount from '@/views/superAdmin/newAccount'
import editAccount from '@/views/superAdmin/editAccount'
import models from '@/views/superAdmin/models'
import dashboard from '@/views/dashboard/main'
import profile from '@/views/profile'

// Gnext 2020 Medical Insurance Card Processing Demo
import micpDemo from '@/views/micp/micpDemo'

// const LogIn = () => import('@/views/auth/LogIn')
// const TrainTemplate = () => import('@/views/templates/Train')
// const uploadProcess = () => import('@/views/process/Upload')
// const processForm = () => import('@/views/forms/process')

Vue.use(Router)

const router = new Router({
  mode: 'history',
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/sign_in',
      name: 'Sign In',
      component: LogIn
    },
    {
      path: '/log_in',
      name: 'Manual Login',
      component: ManualLogin
    },
    {
      path: '/reset_password/:id/:token',
      name: 'ResetPassword',
      component: ResetPassword
    },
    // {
    //   path: '/sign_up',
    //   name: 'Register',
    //   component: Register
    // },
    {
      path: '/auth',
      name: 'Auth',
      component: Auth
    },
    {
      path: '/submit/:tempDocId',
      name: 'submitForm',
      component: submitForm
    },
    {
      path: '/medical_insurance_cards/demo',
      name: 'micpDemo',
      component: micpDemo,
      meta: { requiredAuth: true }
    },
    {
      path: '/',
      redirect: '/dashboard',
      name: 'Home',
      component: Full,
      meta: { requiredAuth: true },
      children: [
        {
          name: 'Dashboard',
          path: '/dashboard',
          component: dashboard
        },
        {
          name: 'My Profile',
          path: '/profile',
          component: profile
        },
        {
          path: '/templates',
          name: 'Templates',
          redirect: '/templates/list',
          component: {
            render (c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'list',
              name: 'Template Listing',
              component: ListTemplate
            },
            {
              path: 'new',
              name: 'New Template',
              component: NewTemplate
            },
            {
              path: ':id',
              name: 'Train',
              component: TrainTemplate
            }
          ]
        },
        {
          path: '/process',
          redirect: '/process/upload',
          name: 'Form',
          component: {
            render (c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'upload',
              name: 'Upload Form',
              component: uploadProcess
            },
            {
              path: 'docs/:docId',
              name: 'Form Doc',
              component: processDoc
            },
            {
              path: 'forms/:id',
              name: 'Verification',
              component: processForm
            },
            {
              path: 'processed',
              name: 'Forms',
              component: processedForms
            },
            {
              path: 'modify/:id',
              name: 'Forms',
              component: modifyProcessType
            }
          ]
        },
        {
          path: '/reports',
          redirect: '/reports/form',
          name: 'Report',
          component: {
            render (c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'form',
              name: 'Reports',
              component: formsReport
            },
            {
              path: 'insights',
              name: 'Reports Insights',
              component: formsInsights
            },
            {
              path: 'logs',
              name: 'Audit Log Report',
              component: auditLogs
            }
          ]
        },
        {
          path: '/audits',
          redirect: '/audits/form',
          name: 'Audits',
          component: {
            render (c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'trail',
              name: 'Log History',
              component: auditsTrail
            }
          ]
        },
        {
          path: '/admin',
          redirect: '/admin/users',
          name: 'Admin Route',
          component: {
            render (c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'users',
              name: 'Users',
              component: users
            },
            {
              path: 'new',
              name: 'Add a New User',
              component: newUser
            },
            {
              path: 'users/:id',
              name: 'Edit User',
              component: editUser
            },
            {
              path: 'form_status',
              name: 'Form Status',
              component: formStatus
            }
          ]
        },
        {
          path: '/super_admin',
          redirect: '/super_admin/accounts',
          name: 'Super Admin',
          component: {
            render (c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'features',
              name: 'Features',
              component: FeatureFlag
            },
            {
              path: 'accounts',
              name: 'Accounts',
              component: accounts
            },
            {
              path: 'new',
              name: 'Add New Account',
              component: newAccount
            },
            {
              path: 'accounts/:id',
              name: 'Edit Account',
              component: editAccount
            },
            {
              path: 'models',
              name: 'MODELS',
              component: models
            }
          ]
        },
        {
          path: '/settings',
          redirect: '/settings/configure',
          name: 'Settings',
          component: {
            render (c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'configure',
              name: 'Configure',
              component: configure
            }
          ]
        },
        {
          path: '/*',
          name: 'page-not-found',
          component: Page404
        }
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiredAuth)) {
    if (to.query._sfdc_canvas_auth === 'user_approval_required') {
      next(`/auth?redirect_to=${to.path}&service=salesforce&loginUrl=${to.query.loginUrl}`)
    } else if (window.localStorage.getItem('idToken')) {
      if (window.localStorage.getItem('accountId') === '73') {
        if (window.localStorage.getItem('role') === 'admin' ||
              to.path === '/medical_insurance_cards/demo') {
          next()
        } else {
          next(`/medical_insurance_cards/demo`)
        }
      } else {
        next()
      }
    } else if (to.path === '/sign_in') {
      next()
    } else {
      Vue.toasted.show('Please login to access the requested page', {
        icon: 'key',
        type: 'error'
      })
      next(`/sign_in?redirect_to=${encodeURIComponent(to.fullPath)}`)
    }
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js